import { waitForElement } from 'theme-utilities';
import { selectors } from './modules/map/init.js';
import { initEventListeners } from './modules/map/listeners.js';
import { initSlider } from './modules/map/slider.js';

waitForElement(selectors.map).then(() => {
	initSlider();
	initEventListeners();
});
